import { useState, useEffect } from "react";
import { db } from "../firebase";
import { collection, getDocs, query, where } from "firebase/firestore";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  TextField,
  Dialog,
  DialogContent,
  Grid,
  Box,
  Button,
  IconButton,
  Collapse,
  AppBar,
  Toolbar
} from "@mui/material";
import { Add, Remove } from "@mui/icons-material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import {fDate} from "../utils/format-time";
import EditIcon from '@mui/icons-material/Edit';
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
const Dashboard = () => {
  const [invoices, setInvoices] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [filter, setFilter] = useState("");
  const [openRows, setOpenRows] = useState({});


  const storage = getStorage();
  const pathReference = ref(storage, 'images/stars.jpg');


  useEffect(() => {
    const fetchInvoices = async () => {
      let q = collection(db, "invoices");
      if (filter) {
        q = query(q, where("client", "==", filter));
      }
      const querySnapshot = await getDocs(q);
      setInvoices(querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    };
    fetchInvoices();
  }, [filter]);

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const toggleRow = (id) => {
    setOpenRows((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const [selectedInvoice, setSelectedInvoice] = useState(null);
const [modalOpen, setModalOpen] = useState(false);


const handleRowClick = (invoice) => {
  setSelectedInvoice({ ...invoice, metadata: { ...invoice.metadata, Items: [...(invoice.metadata?.Items || [])] } });
  setModalOpen(true);
};

const handleCloseModal = () => {
  setModalOpen(false);
  setSelectedInvoice(null);
};

const handleChange = (field, value) => {
  setSelectedInvoice((prev) => ({
    ...prev,
    metadata: { ...prev.metadata, [field]: value },
  }));
};

const handleItemChange = (index, field, value) => {
  const updatedItems = [...selectedInvoice.metadata.Items];
  updatedItems[index][field] = { value };
  setSelectedInvoice((prev) => ({
    ...prev,
    metadata: { ...prev.metadata, Items: updatedItems },
  }));
};

const handleAddItem = () => {
  setSelectedInvoice((prev) => ({
    ...prev,
    metadata: {
      ...prev.metadata,
      Items: [...prev.metadata.Items, { ProductCode: { value: "" }, Description: { value: "" }, Quantity: { value: "" }, UnitPrice: { value: "" }, Amount: { value: "" } }],
    },
  }));
};

const handleRemoveItem = (index) => {
  const updatedItems = selectedInvoice.metadata.Items.filter((_, i) => i !== index);
  setSelectedInvoice((prev) => ({
    ...prev,
    metadata: { ...prev.metadata, Items: updatedItems },
  }));
};

const [url, setUrl] = useState("");


useEffect(() => {

  if (selectedInvoice) {
  const storage = getStorage();
  getDownloadURL(ref(storage, `${selectedInvoice.fileName}`))
  .then((url) => {
    // `url` is the download URL for 'images/stars.jpg'

    setUrl(url)
    // // This can be downloaded directly:
    // const xhr = new XMLHttpRequest();
    // xhr.responseType = 'blob';
    // xhr.onload = (event) => {
    //   const blob = xhr.response;
    // };
    // xhr.open('GET', url);
    // xhr.send();

    // // Or inserted into an <img> element
    // const img = document.getElementById('myimg');
    // img.setAttribute('src', url);
  })
  .catch((error) => {
    // Handle any errors
  });
}

}, [selectedInvoice]);



  return (
    <div>
      <TextField
        label="Filter by Client"
        variant="outlined"
        fullWidth
        margin="normal"
        onChange={(e) => setFilter(e.target.value)}
      />
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>Invoice Number</TableCell>
              <TableCell>PO #</TableCell>
              <TableCell>Vendor</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Amount</TableCell>
              <TableCell>Tax</TableCell>
              <TableCell>Customer VAT Number</TableCell>
              <TableCell>Vendor VAT Number</TableCell>
              <TableCell>Customer Address</TableCell>

              <TableCell>Uploaded</TableCell>

              <TableCell>Status</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {invoices.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((invoice) => (
              <>
                <TableRow key={invoice.id} >
                  <TableCell>
                    <IconButton onClick={() => toggleRow(invoice.id)}>
                      {openRows[invoice.id] ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                    </IconButton>
                  </TableCell>
                  <TableCell>{invoice.metadata?.InvoiceId?.value || ""}</TableCell>
                  <TableCell>{invoice.metadata?.PurchaseOrder?.value || ""}</TableCell>

                  <TableCell>{invoice.metadata?.VendorName?.value || ""}</TableCell>
                  <TableCell>{fDate(invoice.metadata?.InvoiceDate?.value)}</TableCell>
                  <TableCell>{invoice.metadata?.TotalAmount?.value?.amount} {invoice.metadata?.TotalAmount?.value?.currencySymbol}</TableCell>
                  <TableCell>{invoice.metadata?.TotalTax?.value?.amount} {invoice.metadata?.TotalTax?.value?.currencySymbol}</TableCell>
                  <TableCell>{invoice.metadata?.CustomerTaxId?.value || ""}</TableCell>
                  <TableCell>{invoice.metadata?.VendorTaxId?.value || ""}</TableCell>

                  <TableCell>{invoice.metadata?.CustomerAddress?.value?.city} {invoice.metadata?.CustomerAddress?.value?.road} {invoice.metadata?.CustomerAddress?.value?.houseNumber} {invoice.metadata?.CustomerAddress?.value?.postalCode}</TableCell>

                  
                  <TableCell>{fDate(invoice.uploadedAt)}</TableCell>

                  <TableCell>{invoice.status || "Validated"}</TableCell>
                  <TableCell> <IconButton onClick={() => handleRowClick(invoice)}>
                      <EditIcon />
                    </IconButton></TableCell>

                </TableRow>
                <TableRow>
                  <TableCell colSpan={6} style={{ paddingBottom: 0, paddingTop: 0 }}>
                    <Collapse in={openRows[invoice.id]} timeout="auto" unmountOnExit>
                      <Box margin={1}>
                        <Table size="small">
                          <TableHead>
                            <TableRow>
                              <TableCell>Product Code</TableCell>
                              <TableCell>Description</TableCell>
                              <TableCell>Quantity</TableCell>
                              <TableCell>Unit Price</TableCell>
                              <TableCell>Tax</TableCell>
                              <TableCell>Amount</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {invoice.metadata?.Items?.map((item, index) => (
                              <TableRow key={index}>
                                <TableCell>{item.ProductCode?.value || "N/A"}</TableCell>
                                <TableCell>{item.properties?.Description?.value || "N/A"}</TableCell>
                                <TableCell>{item.properties?.Quantity?.value || "N/A"}</TableCell>
                                <TableCell>{item.properties?.UnitPrice?.value?.amount} {item.properties?.UnitPrice?.value?.currencySymbol}</TableCell>
                                <TableCell>{item.Tax?.valueCurrency?.value || "N/A"}</TableCell>
                                <TableCell>{item.properties?.Amount?.value?.amount} {item.properties?.Amount?.value?.currencySymbol}</TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </Box>
                    </Collapse>
                  </TableCell>
                </TableRow>
              </>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={invoices.length}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />


<Dialog
        fullScreen
        // maxWidth={"xl"}
        open={modalOpen}
        onClose={handleCloseModal}>
                  <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleCloseModal}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent>
        
        <Grid container spacing={2}>
        <Grid item xs={8}>
                <embed type="application/pdf" width="100%" height="1200px" src={url} />
          </Grid>
          <Grid item xs={4}>
          {selectedInvoice && (
            <div>
              <h2>Edit Invoice</h2>
              <TextField fullWidth focused margin="normal" label="Invoice Number" color={selectedInvoice.metadata?.InvoiceId?.confidence >= 0.9 ? 'success' : selectedInvoice.metadata?.InvoiceId?.confidence >= 0.7 ? "warning" : "error"} value={selectedInvoice.metadata?.InvoiceId?.value} onChange={(e) => handleChange("InvoiceId", e.target.value)} />
              <TextField fullWidth focused margin="normal" label="Vendor" color={selectedInvoice.metadata?.VendorName?.confidence >= 0.9 ? 'success' : selectedInvoice.metadata?.VendorName?.confidence >= 0.7 ? "warning" : "error"} value={selectedInvoice.metadata?.VendorName?.value} onChange={(e) => handleChange("VendorName", e.target.value)} />
              <TextField fullWidth focused margin="normal" label="Date" color={selectedInvoice.metadata?.InvoiceDate?.confidence >= 0.9 ? 'success' : selectedInvoice.metadata?.InvoiceDate?.confidence >= 0.7 ? "warning" : "error"} value={fDate(selectedInvoice.metadata?.InvoiceDate?.value)} onChange={(e) => handleChange("VendorName", e.target.value)} />
              <TextField fullWidth focused margin="normal" label="Amount" color={selectedInvoice.metadata?.TotalAmount?.confidence >= 0.9 ? 'success' : selectedInvoice.metadata?.TotalAmount?.confidence >= 0.7 ? "warning" : "error"} value={`${selectedInvoice.metadata?.TotalAmount?.value?.amount} ${selectedInvoice.metadata?.TotalAmount?.value?.currencySymbol}`} onChange={(e) => handleChange("VendorName", e.target.value)} />
              <TextField fullWidth focused margin="normal" label="Tax" color={selectedInvoice.metadata?.TotalTax?.confidence >= 0.9 ? 'success' : selectedInvoice.metadata?.TotalTax?.confidence >= 0.7 ? "warning" : "error"} value={`${selectedInvoice.metadata?.TotalTax?.value?.amount || ""} ${selectedInvoice.metadata?.TotalTax?.value?.currencySymbol}`} onChange={(e) => handleChange("VendorName", e.target.value)} />
              <TextField fullWidth focused margin="normal" label="Customer VAT Number" color={selectedInvoice.metadata?.CustomerTaxId?.confidence >= 0.9 ? 'success' : selectedInvoice.metadata?.CustomerTaxId?.confidence >= 0.7 ? "warning" : "error"}  value={selectedInvoice.metadata?.CustomerTaxId?.value} onChange={(e) => handleChange("VendorName", e.target.value)} />
              <TextField fullWidth focused margin="normal" label="Customer Address" color={selectedInvoice.metadata?.CustomerAddress?.confidence >= 0.9 ? 'success' : selectedInvoice.metadata?.CustomerAddress?.confidence >= 0.7 ? "warning" : "error"} value={`${selectedInvoice.metadata?.CustomerAddress?.value?.city || ""} ${selectedInvoice.metadata?.CustomerAddress?.value?.road || ""} ${selectedInvoice.metadata?.CustomerAddress?.value?.houseNumber || ""} ${selectedInvoice.metadata?.CustomerAddress?.postalCode || ""}`} onChange={(e) => handleChange("VendorName", e.target.value)} />
              <h3>Items</h3>
              {selectedInvoice.metadata.Items.map((item, index) => (
                <Box key={index} display="flex" gap={2} alignItems="center" mb={3}>
                  <TextField label="Description" value={item.properties?.Description?.value} onChange={(e) => handleItemChange(index, "Description", e.target.value)} />
                  <TextField label="Quantity" value={item.properties?.Quantity?.value || ""} onChange={(e) => handleItemChange(index, "Description", e.target.value)} />

                  <TextField label="Amount" value={`${item.properties?.Amount?.value?.amount || ""} ${item.properties?.Amount?.value?.currencySymbol || ""}`} onChange={(e) => handleItemChange(index, "Description", e.target.value)} />
                  <IconButton onClick={() => handleRemoveItem(index)}><Remove /></IconButton>
                </Box>
              ))}
              <Button onClick={handleAddItem} startIcon={<Add />}>Add Item</Button>
              <Button onClick={handleCloseModal} variant="contained" color="primary" fullWidth>Save</Button>
            </div>
          )}
          </Grid>
        </Grid>
        </DialogContent>

      </Dialog>
    </div>
  );
};

export default Dashboard;
